import { render, staticRenderFns } from "./InvoiceLicenseList.vue?vue&type=template&id=8c8a00a2&scoped=true"
import script from "./InvoiceLicenseList.vue?vue&type=script&lang=js"
export * from "./InvoiceLicenseList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceLicenseList.vue?vue&type=style&index=0&id=8c8a00a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8a00a2",
  null
  
)

export default component.exports